'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const QuestionIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M11.6 14.7C11.6 14.2 11.7 13.7 12.1 13.3C12.6 12.7 13.3 12.5 13.8 12C14.3 11.5 14.6 10.8 14.6 10.2C14.6 8.79999 13.4 7.59999 12 7.59999C10.6 7.59999 9.50005 8.69999 9.40005 9.99999C9.40005 10.1 9.40005 10.4 9.40005 10.4M21.2001 12C21.2001 17.081 17.0811 21.2 12 21.2C6.91903 21.2 2.80005 17.081 2.80005 12C2.80005 6.91897 6.91903 2.79999 12 2.79999C17.0811 2.79999 21.2001 6.91897 21.2001 12Z",
          stroke: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M11.6001 17.5C12.0971 17.5 12.5001 17.0971 12.5001 16.6C12.5001 16.103 12.0971 15.7 11.6001 15.7C11.103 15.7 10.7001 16.103 10.7001 16.6C10.7001 17.0971 11.103 17.5 11.6001 17.5Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
const VpQuestionIcon = forwardRef(QuestionIcon);

export { VpQuestionIcon as default };
